import { TableCell, TableRow } from "@material-ui/core";
import React from "react";

import FormContextTextField from "../../../../forms/formik/FormContextInputs/FormContextTextField";

import ConfirmationCellContent from "./ConfirmationCellContent";
import NoActionNeeded from "./NoActionNeeded";
import PreAssignmentDescriptionPopover from "./PreAssignmentDescriptionPopover";

function TextFieldRow({ checklistItem, editable, fieldId }) {
  return (
    <TableRow data-cy="checklist-item-text-row">
      <TableCell>
        <div className="bold">{checklistItem.name}</div>
        <PreAssignmentDescriptionPopover {...checklistItem} />
      </TableCell>
      <TableCell align="center">
        <NoActionNeeded
          {...{
            checklistItem,
            editable,
            Editing: (
              <FormContextTextField
                id={`${fieldId}.textValue`}
                style={{ marginBottom: 0, width: "75%" }}
              />
            ),
            Viewing: <div>{checklistItem.textValue}</div>,
          }}
        />
      </TableCell>
      <TableCell>
        <ConfirmationCellContent {...{ checklistItem }} />
      </TableCell>
    </TableRow>
  );
}

export default TextFieldRow;
